(() => {
  'use strict';
  const config = document.currentScript?.dataset || {};
  const locale = String(config.locale || document.documentElement.lang || 'en');
  if (locale === 'en' || window.Shopify?.designMode || window.VavorinTranslation) return;
  if (/^(?:\/[a-z]{2}(?:-[a-z0-9]+)?)?\/(?:checkouts?|account|orders|apps|challenge|password)(?:\/|$)/i.test(location.pathname)) return;
  const targets = {cs:'cs',da:'da',de:'de',el:'el',es:'es',fi:'fi',fr:'fr',hu:'hu',it:'it',nl:'nl',no:'no','pt-PT':'pt-PT',pl:'pl',ro:'ro',sv:'sv','zh-CN':'zh-CHS'};
  if (!targets[locale]) return;
  const state = window.VavorinTranslation = {locale,status:'ready',translated:0,failed:0};
  const excluded = 'script,style,noscript,svg,code,pre,input,textarea,select,option,[contenteditable],.notranslate,[translate="no"],.money,[class*="price"],[data-price],[data-sku],.sku,.cart-bubble,shopify-account,shopify-accelerated-checkout,#shopify-pc__banner,form[action*="localization"]';
  const cache = new Map(), pending = new Map(), processed = new WeakMap();
  const storageKey = 'vavorin-translation-v1-'+locale;
  try {for (const [key,value] of JSON.parse(sessionStorage.getItem(storageKey)||'[]')) cache.set(key,value);} catch {}
  let running = false, timer;
  function keepLanguage() {
    const root = String(config.root || '/').replace(/\/$/,'');
    for (const element of document.querySelectorAll('a[href],form[action]')) {
      if (element.closest('form[action*="localization"]') || element.matches('form[action*="localization"]')) continue;
      const attribute = element.tagName === 'FORM' ? 'action' : 'href';
      try {
        const url = new URL(element.getAttribute(attribute),location.origin);
        if (url.origin !== location.origin) continue;
        const match = url.pathname.match(/^(?:\/(?:cs|da|de|el|es|fi|fr|hu|it|nl|no|pl|pt|pt-pt|ro|sv|zh|zh-cn))?\/(products|collections|pages|cart|search)(\/.*)?$/i);
        if (!match) continue;
        const path = root+'/'+match[1]+(match[2]||'')+url.search+url.hash;
        if (element.getAttribute(attribute)!==path) element.setAttribute(attribute,path);
      } catch {}
    }
  }
  function scan(root) {
    const walker = document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode, parent = node.parentElement;
      if (!parent || parent.closest(excluded)) continue;
      const raw = node.nodeValue, text = raw.trim();
      // This fallback targets English text left after native translations, including new products.
      if (!text || text.length>2500 || !/[A-Za-z]{3}/.test(text) || /[\u3400-\u9fff\u3040-\u30ff\u0400-\u052f]/.test(text) || /^https?:|\S+@\S+|^VAVORIN(?:™)?$/i.test(text)) continue;
      if (processed.get(node)===raw) continue;
      if (cache.has(text)) {node.nodeValue=raw.replace(text,cache.get(text));processed.set(node,node.nodeValue);continue;}
      if (!pending.has(text)) pending.set(text,[]);
      pending.get(text).push({node,raw});processed.set(node,raw);
    }
  }
  async function flush() {
    if (running || !pending.size) return;
    running=true;state.status='translating';
    try {
      while (pending.size) {
        const batch=[];let length=0;
        for (const [text,nodes] of pending) {if(batch.length>=100 || length+text.length>12000) break;batch.push([text,nodes]);length+=text.length;}
        if (!batch.length) break;
        for (const [text] of batch) pending.delete(text);
        try {
          const response = await fetch('https://edge.microsoft.com/translate/translatetext?from=en&to='+encodeURIComponent(targets[locale])+'&isEnterpriseClient=false',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(batch.map(([text])=>text)),signal:AbortSignal.timeout(12000),credentials:'omit'});
          if (!response.ok) throw new Error('Translation unavailable');
          const result=await response.json();if(result.length!==batch.length) throw new Error('Incomplete translation');
          batch.forEach(([text,nodes],index)=>{const translated=result[index]?.translations?.[0]?.text;if(!translated){state.failed++;for(const {node}of nodes)processed.delete(node);return;}cache.set(text,translated);for(const {node,raw}of nodes){if(node.isConnected&&node.nodeValue===raw){node.nodeValue=raw.replace(text,translated);processed.set(node,node.nodeValue);state.translated++;}}});
        } catch {state.failed+=batch.length;for(const [,nodes]of batch)for(const {node}of nodes)processed.delete(node);}
      }
      try {sessionStorage.setItem(storageKey,JSON.stringify([...cache].slice(-400)));} catch {}
    } finally {running=false;state.status=state.failed?'original-visible-on-failure':'ready';}
  }
  function update() {keepLanguage();scan(document.body);void flush();}
  function schedule(){clearTimeout(timer);timer=setTimeout(update,250);}
  keepLanguage();
  new MutationObserver(records=>{if(records.some(r=>r.addedNodes.length || (r.type==='characterData' && processed.get(r.target)!==r.target.nodeValue)))schedule();}).observe(document.body,{childList:true,characterData:true,subtree:true});
  window.addEventListener('online',schedule);
  document.addEventListener('shopify:section:load',schedule);
  if ('requestIdleCallback' in window) requestIdleCallback(update,{timeout:1200});else setTimeout(update,0);
})();
